<template>
    <div class="fixed z-10 inset-0 overflow-y-auto" role="dialog" @click.stop>
        <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div class="fixed inset-0 opacity-25 bg-gray-500 dark:bg-gray-100 transition-opacity"
                 @click="$emit('closeModal')"></div>
            <div
                class="inline-block z-20 bg-white dark:bg-gray-800 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full md:max-w-3xl">
                <div class="bg-white dark:bg-gray-800 p-4">
                    <div class="sm:flex sm:items-start" style="max-height: 350px; overflow-y: auto">
                        <div class="mt-3 text-center sm:mt-0 w-full sm:text-left">
                            <div class="flex flex-row items-center mb-4">
                                <MapPinIcon class="w-6 h-6 mr-3 text-gray-900 dark:text-gray-100"/>
                                <h3 class="text-lg leading-6 text-gray-900 dark:text-gray-100">
                                    Enviar Localização
                                </h3>
                            </div>
                            <div>
                                <p class="text-md ml-2 text-start text-gray-600 dark:text-gray-300 mb-6">
                                    Selecione a localização que você deseja enviar:
                                </p>
                                <table class="min-w-full divide-y divide-gray-200 dark:divide-gray-700 w-full">
                                    <thead class="bg-gray-50 dark:bg-gray-700">
                                    <tr>
                                        <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider"
                                            scope="col">
                                            Nome
                                        </th>
                                        <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider"
                                            scope="col">
                                            Mensagem
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <template v-for="location in locations">
                                        <tr :class="[rowClass(location)]"
                                            class="cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600"
                                            @click="selectedLocation = location">
                                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-300">
                                                {{ location.name }}
                                            </td>
                                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-300">
                                                {{ location.message }}
                                            </td>
                                        </tr>
                                    </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bg-gray-50 dark:bg-gray-700 px-4 py-6 flex flex-row-reverse gap-4">
                    <button
                        :disabled="selectedLocation.id === 0"
                        class="disabled:opacity-25 cursor-pointer disabled:cursor-auto text-sm justify-center rounded-md border shadow-sm px-4 py-3 bg-red-600 text-white hover:bg-red-700 dark:bg-red-700 dark:hover:bg-red-800"
                        type="button"
                        @click="sendLocation"
                    >
                        Enviar Localização
                    </button>
                    <button
                        class="text-sm justify-center cursor-pointer rounded-md border border-gray-300 dark:border-gray-600 shadow-sm px-4 py-3 bg-white dark:bg-gray-600 text-gray-700 dark:text-gray-100 hover:bg-gray-100 dark:hover:bg-gray-500"
                        type="button"
                        @click="$emit('closeModal')"
                    >
                        Cancelar
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import {MapPinIcon} from "@heroicons/vue/24/outline";
import {ref} from "vue"
import {Location} from "@src/types";
import {useLocations} from "@src/composables/useLocations";
import MessageService from "@src/services/message";
import {useChatSessionStore} from "@src/stores/chatSession";

const emit = defineEmits(['closeModal'])
const locationsComposable = useLocations()
const locations = locationsComposable.getLocations()
const sessionStore = useChatSessionStore();
let impar = false
let selectedLocation = ref<Location>({
    id: 0,
    name: '',
    message: ''
})
const rowClass = (location: Location) => {
    impar = !impar
    let css = 'cursor-pointer'
    css += (impar) ? ' bg-white dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-600' : ' bg-gray-50 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600'
    css += (selectedLocation.value.id === location.id) ? ' bg-indigo-100 dark:bg-gray-900' : ''
    return css
}

const sendLocation = async () => {
    sessionStore.openAttachSelector = false

    await MessageService.sendLocation(selectedLocation.value?.id || 0, (sessionStore.replyMessage?.id as number) || 0)

    sessionStore.replyMessage = undefined

    selectedLocation.value = {
        id: 0,
        name: '',
        message: ''
    }

    sessionStore.scrollDown()
    emit('closeModal')
}
</script>


<style scoped>
</style>